import React from 'react';

const PUB = process.env.PUBLIC_URL || '';

// Landing screen — ports the phone WelcomeScreen: hero, title below, one 進入書庫 button.
export default function Welcome({ onEnter }) {
  return (
    <div className="welcome">
      <div className="welcome-hero">
        <img src={PUB + '/welcome-hero.jpg'} alt="" />
      </div>
      <h1 className="welcome-title">Kari Utux Baro</h1>
      <p className="welcome-sub">3S4T賽德克語聖經</p>
      <p className="welcome-intro">
        學習賽德克語的有聲閱讀工具，收錄德固達雅、都達與太魯閣語類的讀物——有聲朗讀、逐詞高亮，
        點擊單詞可標記學習進度。
      </p>
      <button className="welcome-btn" onClick={onEnter}>進入書庫</button>
      <p className="welcome-note">語言保存計畫</p>
    </div>
  );
}
